

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    News Section Component-->
    <news-page-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import NewsPageArea from "../components/news/NewsPageArea";

export default {
  name: 'News',
  components: {NewsPageArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Product Details',
        link: 'Product Details'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/News.vue